<template>
  <div id="voteDetail">
    <div class="title_bar">
      <div class="left">
        <div class="title-wrap">
          <span class="vote-title">{{ newsData.Title }}</span>
          <span
            v-if="newsData.Tag.indexOf('重要事務') !== -1"
            class="tag important"
          >重要事務</span>
          <span
            v-if="newsData.Tag.indexOf('開放留言') !== -1"
            class="tag canComment"
          >開放留言</span>
        </div>
      </div>
      <div class="right">
        <el-button
          v-if="newsData.IsCheck === 0"
          plain
          @click="$router.push({name:'voteEdit', params: { id: newsData.Id }})"
        >
          編輯
        </el-button>
        <el-button
          v-if="newsData.IsCheck !== 1 && newsData.IsCheck !== null"
          type="danger"
          plain
          @click="deleteVote"
        >
          刪除
        </el-button>
      </div>
    </div>
    <div class="blockWrap">
      <el-form
        ref="feeDetailEdit"
        class="list"
        status-icon
        label-position="left"
      >
        <el-form-item
          label=""
          class="Detail"
        >
          {{ newsData.Detail }}
        </el-form-item>
        <el-form-item
          label="投票期間"
          class="Interval"
        >
          <template>{{ filterDate(newsData.Start) }} 至 {{ filterDate(newsData.Due) }}</template>
        </el-form-item>
        <el-form-item label="投票者限制">
          <template>{{ filterVoterType(newsData.Type) }}</template>
        </el-form-item>
        <el-form-item label="是否開放留言">
          <template>{{ newsData.Tag.indexOf('開放留言') !== -1 ? '開放' : '不開放' }}</template>
        </el-form-item>
        <el-form-item label="當前投票數量">
          <template>{{ newsData.AlreadyVoteCount }}/{{ newsData.ShouldVoteCount }}</template>
        </el-form-item>

        <el-form-item label="附加文件">
          <template>
            <ul class="fileList">
              <li
                v-for="(file,file_ind) in newsData.Files"
                :key="file_ind"
                class="fileList-item"
              >
                <a :href="file.uploadUrl">文件{{ file_ind + 1 }}</a>
              </li>
            </ul>
          </template>
        </el-form-item>
        <el-form-item label="附加圖片">
          <template>
            <div class="file-wrap">
              <img
                v-for="(image, imageIndex) in newsData.ImageFiles"
                :key="imageIndex"
                class="file"
                :src="image.uploadUrl"
                alt=""
                @click="lightboxIndex = imageIndex"
              >
            </div>
          </template>
        </el-form-item>
      </el-form>
    </div>
    <div
      v-for="(item, index) in questionData"
      :key="item.Id"
      class="questionBlock"
    >
      <div class="question-title-wrap">
        <span class="questionTitle">問題{{ index + 1 }} {{ item.Title }}</span>
        <span class="tag">{{ filterQuestionType(item.Type) }}</span>
      </div>
      <div class="questionNote">
        {{ item.Description }}
      </div>
      <div class="candidateBlock">
        <div
          v-for="optionItem in item.optionData"
          :key="optionItem.Id"
          class="candidate"
          @click="openDialog(item, index, optionItem)"
        >
          <img
            v-if="optionItem.Image[0]"
            :src="optionItem.Image[0].uploadUrl"
            alt=""
          >
          <div class="candidateContent">
            <div class="candidateTitle">
              {{ optionItem.Content }}
            </div>
            <div class="candidateNote">
              {{ optionItem.Note }}
            </div>
            <div class="progressPercent">
              投票數 {{ optionItem.VoteCount }} / {{ item.TotalVoteCount === 0 ? 0 : Math.round(optionItem.VoteCount / item.TotalVoteCount * 100) }}%
            </div>
            <el-progress
              text-inside
              :stroke-width="20"
              :percentage="item.TotalVoteCount === 0 ? 0 : optionItem.VoteCount / item.TotalVoteCount * 100"
              :format="format"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="bottomControl">
      <el-button
        v-if="newsData.IsCheck === 1"
        @click="exitVote"
      >
        終止此項投票
      </el-button>
      <el-button @click="$router.push({name:'voteList'})">
        返回投票列表
      </el-button>
    </div>
    <CoolLightBox
      :items="images"
      :index="lightboxIndex"
      :slideshow="false"
      @close="lightboxIndex = null"
      @on-open="lightBoxOpen"
    />
    <el-dialog
      title="投給此選項的投票者"
      class="candidateDialog"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div class="dialogQuestionTitle">
        問題{{ tempOption.Index + 1 }} {{ tempOption.QuestionTitle }}
      </div>
      <div class="candidate">
        <img
          v-if="tempOption.Image && tempOption.Image[0]"
          :src="tempOption.Image[0].uploadUrl"
          alt=""
          @click="openOptionLightbox(tempOption.Image[0].uploadUrl)"
        >
        <div class="candidateContent">
          <div class="candidateTitle">
            {{ tempOption.Content }}
          </div>
          <div class="candidateNote">
            {{ tempOption.Note }}
          </div>
          <div class="progressPercent">
            投票數 {{ tempOption.VoteCount }} / {{ tempOption.TotalVoteCount === 0 ? 0 : Math.round(tempOption.VoteCount / tempOption.TotalVoteCount * 100) }}%
          </div>
          <el-progress
            text-inside
            :stroke-width="20"
            :percentage="tempOption.TotalVoteCount === 0 ? 0 : tempOption.VoteCount / tempOption.TotalVoteCount * 100"
            :format="format"
          />
        </div>
      </div>
      <div class="voterBlock">
        <div class="voterTitle">
          投票者
        </div>
        <div
          v-if="tempOption.VoteRecord && tempOption.VoteRecord.length"
          class="voterDetail"
        >
          <div
            v-for="(item, index) in tempOption.VoteRecord"
            :key="index"
            class="voter"
          >
            <div class="voterTablet">
              {{ item.Community }} {{ item.Tablet }}
            </div>
            <div
              v-if="item.Note"
              class="voterMessage"
            >
              {{ item.Note }}
            </div>
            <div
              v-if="item.Name"
              class="voterInfo"
            >
              <div>
                <i
                  class="icon-user"
                  aria-hidden="true"
                />
                {{ item.Name }}
              </div>
              <div>
                <span class="voterContactInfo">{{ item.Phone }}</span>
                <span class="voterContactInfo">{{ item.Email }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="voterEmpty"
        >
          尚無投票
        </div>
      </div>
      <CoolLightBox
        :items="optionLightbox.item"
        :index="optionLightbox.index"
        :slideshow="false"
        @close="optionLightbox.index = null"
      />
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      newsData: {
        Id: 0,
        Title: '',
        Detail: '',
        Start: '',
        Due: '',
        Type: 0,
        Files: [],
        ImageFiles: [],
        Tag: [],
        AlreadyVoteCount: 0,
        ShouldVoteCount: 0,
        IsCheck: null
      },
      questionData: [
        {
          Id: 0,
          Title: '',
          Description: '',
          Type: 0,
          TotalVoteCount: 0,
          optionData: [
            {
              Id: 0,
              Image: [],
              Content: '',
              Note: '',
              VoteCount: 0
            }
          ]
        }
      ],
      tempOption: {},
      lightboxIndex: null,
      dialogVisible: false,
      optionLightbox: {
        item: [],
        index: null
      }
    }
  },
  computed: {
    images () {
      const images = this.newsData.ImageFiles.map(item => {
        return item.uploadUrl
      })
      return images
    }
  },
  mounted () {
    this.getVote()
  },
  methods: {
    // 取得投票內容
    getVote () {
      if (this.$route.params.id) {
        apiVote.Vote.GetVote({ VotingId: this.$route.params.id }).then(res => {
          console.log(res)
          const tag = []
          if (res.data.Data.IsImportant) {
            tag.push('重要事務')
          }
          if (res.data.Data.CanComment) {
            tag.push('開放留言')
          }
          const allFiles = JSON.parse(res.data.Data.Files.replace(/name:/g, '"name":').replace(/type:/g, '"type":'))
          const files = []
          allFiles.forEach(item => {
            if (item.type === 'file') {
              files.push({
                file: '',
                uploadUrl: `${res.data.Data.Url}${item.name}`
              })
            }
          })
          const imageFiles = []
          allFiles.forEach(item => {
            if (item.type === 'image') {
              imageFiles.push({
                type: 'img',
                BS64: '',
                file: '',
                uploadUrl: `${res.data.Data.Url}${item.name}`
              })
            }
          })
          this.newsData = {
            Id: res.data.Data.Id,
            Title: res.data.Data.Title,
            Detail: res.data.Data.Content,
            Start: new Date(res.data.Data.StartTime.replace('T', ' ').replace('Z', '')),
            Due: new Date(res.data.Data.DueTime.replace('T', ' ').replace('Z', '')),
            Type: res.data.Data.VoterType,
            Files: files,
            ImageFiles: imageFiles,
            Tag: tag,
            AlreadyVoteCount: res.data.Data.AlreadyVote,
            ShouldVoteCount: res.data.Data.ShouldVote,
            IsCheck: res.data.Data.IsCheck
          }
          const questions = []
          res.data.Data.Questions.forEach(item => {
            const options = []
            let totalVoteCount = 0
            item.Candidates.forEach(optionItem => {
              totalVoteCount += optionItem.VoteCount
              options.push({
                Id: optionItem.Id,
                Image: optionItem.Image
                  ? [{
                      BS64: '',
                      file: '',
                      uploadUrl: `${res.data.Data.Url}${optionItem.Image}`
                    }]
                  : [],
                Content: optionItem.Content,
                Note: optionItem.Note,
                VoteCount: optionItem.VoteCount
              })
            })
            questions.push({
              Id: item.Id,
              Title: item.Topic,
              Description: item.Description,
              Type: item.Type,
              optionData: options,
              TotalVoteCount: totalVoteCount
            })
          })
          this.questionData = questions
        }).catch(err => {
          console.log(err)
        })
      }
    },
    filterVoterType (type) {
      switch (type) {
        case 0:
          return '一戶一票'
        case 1:
          return '一人一票'
      }
    },
    filterQuestionType (type) {
      switch (type) {
        case 0:
          return '單選題'
        case 1:
          return '多選題'
      }
    },
    filterDate (date) {
      if (date) {
        const YYYY = date.getFullYear()
        const MM = (date.getMonth() + 1) < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
        const DD = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
        const HH = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
        const mm = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
        return `${YYYY}-${MM}-${DD} ${HH}:${mm}`
      }
    },
    format () {
      return ''
    },
    openDialog (question, questionIndex, option) {
      apiVote.Vote.GetOptionVoteRecord({
        VotingId: this.$route.params.id,
        CandidateId: option.Id
      }).then(res => {
        console.log(res.data)
        this.tempOption = {
          Content: option.Content,
          Note: option.Note,
          Image: option.Image,
          VoteCount: option.VoteCount,
          TotalVoteCount: question.TotalVoteCount,
          Index: questionIndex,
          QuestionTitle: question.Title,
          VoteRecord: res.data.Data
        }
        this.dialogVisible = true
      }).catch(err => {
        console.log(err)
      })
    },
    openOptionLightbox (image) {
      this.optionLightbox.item = [image]
      this.optionLightbox.index = 0
    },
    // 刪除投票
    deleteVote () {
      this.$confirm('是否刪除此項投票', '', {
        confirmButtonText: '刪除',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: '取消',
        closeOnClickModal: false
      }).then(action => {
        apiVote.Vote.DeleteVote({
          VotingId: this.$route.params.id
        }).then(res => {
          this.$store.commit('ifVoteEdit', true)
          this.$router.push({ name: 'voteList' })
          this.$message({
            type: 'success',
            message: '刪除成功'
          })
        }).catch(err => {
          console.log(err)
          this.$message({
            type: 'error',
            message: '刪除失敗'
          })
        })
      }).catch(() => {
      })
    },
    lightBoxOpen () {
      if (document.querySelector('.cool-lightbox-toolbar__btn[title="Show thumbnails"]')) { document.querySelector('.cool-lightbox-toolbar__btn[title="Show thumbnails"]').style.display = 'none' }
    },
    // 終止投票
    exitVote () {
      this.$confirm('終止將使投票提早結束，且投票項目無法重新啟用，是否確認終止?', '', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        closeOnClickModal: false
      }).then(action => {
        apiVote.Vote.DoneVote({
          votingId: this.$route.params.id
        }).then(res => {
          this.$store.commit('ifVoteEdit', true)
          this.$router.push({ name: 'voteList' })
          this.$message({
            type: 'success',
            message: '終止成功'
          })
        }).catch(err => {
          console.log(err)
          this.$message({
            type: 'error',
            message: '終止失敗'
          })
        })
      }).catch(() => {
      })
    }
  }
}
</script>
<style lang="sass" scoped>
#voteDetail
  padding: 50px 0
  ::v-deep .el-dialog
    +basicDialog
    p
      line-height: 25px

  .title_bar
    display: flex
    justify-content: space-between
    align-items: center
    .title-wrap
      display: flex
      align-items: center
      .vote-title
        color: $mainColor
        font-size: 30px
        margin-right: 10px
      .tag
        margin-right: 10px
        color: #fff
        padding: 4px 12px
        &.important
          background-color: $warnColor
        &.canComment
          background-color: $infoColor
    .el-button.disabled
      opacity: 0.3
      pointer-events: none
  ::v-deep .el-form.list
    display: inline-flex
    flex-wrap: wrap
    width: 100%
    .el-form-item
      display: flex
      align-items: flex-start
      width: 100%
      box-sizing: border-box
      +basicForm
      &.Interval
        width: 50%
      &__label
        font-weight: bold
        flex-basis: 105px
        vertical-align: top
        text-align: right
      &__content
        flex: 1
        // max-width: 400px
        .el-select,.el-date-editor
          width: 100%
        .fileList
          padding-left: 40px
          .fileList-item
            list-style-type: disc
            line-height: 1.5
            a
              color: #000
              &:hover
                text-decoration: underline
        .file-wrap
          display: flex
          flex-wrap: wrap
          .file
            max-width: 280px
            border: 1px solid #ccc
            color: #666
            border-radius: 4px
            cursor: pointer
            margin: 10px
            position: relative
            overflow: hidden
            background-position: center
            background-size: cover
            &:hover
              color: #333
              border: 1px solid #aaa
              box-shadow: inset 0 1px 2px -1px rgba(0,0,0,.075), 0 0 8px rgba(120,120,120,.5)
              transition: .4s
              .optionBtn-wrap
                bottom: 0
      &.Detail
        > .el-form-item__content
          line-height: initial
          word-break: break-word
  .blockWrap
    text-align: left
    display: inline-flex
    flex-wrap: wrap
    width: 100%
    margin-bottom: 30px
    padding: 0 70px 0 30px
    box-sizing: border-box
    +NewsStatusTag
  .questionBlock
    box-sizing: border-box
    width: 100%
    border: 1px solid $borderDark1
    padding: 30px 35px
    text-align: left
    .question-title-wrap
      margin-bottom: 10px
      .questionTitle
        font-size: 30px
        font-weight: bold
      .tag
        color: $mainColor
        background-color: #eee
        padding: 3px 5px
        font-weight: bold
        margin-left: 15px
    .questionNote
      font-size: 17px
      margin-bottom: 30px
    .candidate
      display: flex
      border: 1px solid $borderDark1
      padding: 20px
      cursor: pointer
      transition: 0.3s
      &:hover
        transform: translateX(-3px) translateY(-3px)
      img
        width: 177px
        margin-right: 10px
      .candidateContent
        width: 100%
        .candidateTitle
          font-size: 24px
          font-weight: bold
        .candidateNote
          font-size: 17px
          margin-top: 15px
        .progressPercent
          text-align: right
          margin-top: 15px
          font-size: 17px
        .el-progress
          margin-top: 10px
  .bottomControl
    text-align: center
    padding: 30px 0 0
  .candidateDialog
    ::v-deep .el-dialog__body
      color: #333
    .dialogQuestionTitle
      font-size: 36px
      font-weight: bold
      margin-bottom: 10px
    .candidate
      display: flex
      padding: 20px
      margin-bottom: 20px
      img
        width: 160px
        margin-right: 10px
        border: 1px solid $borderDark1
        cursor: pointer
        &:hover
          border: 1px solid #aaa
          box-shadow: inset 0 1px 2px -1px rgba(0,0,0,.075), 0 0 8px rgba(120,120,120,.5)
          transition: .4s
      .candidateContent
        width: 100%
        .candidateTitle
          font-size: 24px
          font-weight: bold
        .candidateNote
          font-size: 17px
          margin-top: 15px
        .progressPercent
          text-align: right
          margin-top: 15px
          font-size: 17px
        .el-progress
          margin-top: 10px
    .voterBlock
      .voterTitle
        font-size: 24px
        font-weight: bold
        padding-bottom: 20px
        border-bottom: 1px solid $borderDark1
      .voterDetail
        .voter
          padding: 15px 0
          border-bottom: 1px solid $borderDark1
          .voterTablet
            font-size: 20px
          .voterMessage
            padding: 20px 0
            margin-left: 26px
            border-bottom: 1px solid $borderDark1
          .voterInfo
            display: flex
            justify-content: space-between
            padding-top: 10px
            margin-left: 26px
            opacity: .43
            .voterContactInfo
              margin-left: 20px
      .voterEmpty
        text-align: center
        font-size: 20px
        margin-top: 20px
</style>
